"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundColor = void 0;
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["WHITE"] = "white";
    BackgroundColor["GRAY"] = "gray";
    BackgroundColor["BLUE"] = "blue";
})(BackgroundColor = exports.BackgroundColor || (exports.BackgroundColor = {}));
